import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ShoppingBag, ArrowLeft, ShieldCheck, CreditCard, Smartphone } from "lucide-react";
import { toast } from "sonner";
import { api, eur } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function ProductoDetalle() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [qty, setQty] = useState(1);
  const { add } = useCart();

  useEffect(() => {
    api.get(`/products/${id}`).then(({ data }) => setProduct(data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound)
    return (
      <div className="max-w-7xl mx-auto px-5 py-32 text-center" data-testid="product-not-found">
        <p className="text-white/50">Producto no encontrado.</p>
        <Link to="/tienda" className="btn-gold mt-8">Volver a la tienda</Link>
      </div>
    );

  if (!product)
    return <div className="py-32 flex justify-center"><div className="w-8 h-8 border-2 border-gold border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 lg:py-20" data-testid="product-detail-page">
      <Link to="/tienda" className="inline-flex items-center gap-2 text-white/50 hover:text-gold text-xs uppercase tracking-[0.15em] transition-colors duration-200" data-testid="back-to-shop">
        <ArrowLeft size={14} /> Volver a la tienda
      </Link>
      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-12">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }} className="relative h-[340px] lg:h-[520px] overflow-hidden">
          <img src={product.image} alt={product.name} className="w-full h-full object-cover" />
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }}>
          <p className="overline-gold mb-3">{product.category}</p>
          <h1 className="text-3xl lg:text-5xl text-white font-light tracking-tight" data-testid="product-name">{product.name}</h1>
          <p className="font-heading text-4xl text-gold mt-6" data-testid="product-price">{product.price > 0 ? eur(product.price) : "Precio a consultar"}</p>
          <p className="mt-6 text-white/65 font-light leading-relaxed" data-testid="product-description">{product.description}</p>

          {product.price > 0 ? (
            <>
              <div className="mt-8 flex items-center gap-5">
                <div className="flex items-center border border-white/15">
                  <button onClick={() => setQty(Math.max(1, qty - 1))} className="px-4 py-3 text-white/70 hover:text-gold transition-colors" data-testid="qty-minus">−</button>
                  <span className="px-4 text-white" data-testid="qty-value">{qty}</span>
                  <button onClick={() => setQty(Math.min(20, qty + 1))} className="px-4 py-3 text-white/70 hover:text-gold transition-colors" data-testid="qty-plus">+</button>
                </div>
                <button onClick={() => { add(product, qty); toast.success("Añadido al carrito"); }} className="btn-gold-solid flex-1" data-testid="add-to-cart">
                  <ShoppingBag size={16} /> Añadir al Carrito
                </button>
              </div>
              <Link to="/checkout" className="btn-ghost-light mt-4 w-full" data-testid="go-checkout">Ir al Checkout</Link>
            </>
          ) : (
            <a href={`https://wa.me/34678783000?text=${encodeURIComponent(`Hola, me interesa: ${product.name}. ¿Precio y disponibilidad?`)}`} target="_blank" rel="noopener noreferrer"
              className="btn-gold-solid mt-8 w-full" data-testid="consult-whatsapp">
              Consultar por WhatsApp · 678 783 000
            </a>
          )}

          <div className="mt-10 border-t border-white/10 pt-8 grid grid-cols-3 gap-4 text-center">
            <div><ShieldCheck size={20} strokeWidth={1.25} className="text-gold mx-auto mb-2" /><p className="text-[10px] uppercase tracking-[0.15em] text-white/50">Pago Seguro</p></div>
            <div><CreditCard size={20} strokeWidth={1.25} className="text-gold mx-auto mb-2" /><p className="text-[10px] uppercase tracking-[0.15em] text-white/50">Redsys</p></div>
            <div><Smartphone size={20} strokeWidth={1.25} className="text-gold mx-auto mb-2" /><p className="text-[10px] uppercase tracking-[0.15em] text-white/50">Bizum</p></div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
